
<app-data-printer [categories]="categories"></app-data-printer>

<ng-template #warrantyDetails let-warranty="warranty">
    <div class="warranty-details-template">
        <span class="warranty-label">
            {{ warranty?.propiedadDireccion?.calle }} {{ warranty?.propiedadDireccion?.numero }} {{ warranty?.propiedadDireccion?.piso }} {{ warranty?.propiedadDireccion?.departamento }}
        </span>
        <button mat-raised-button class="garantor-button mini" color="primary" routerLink="/garantias/{{ warranty?.id }}">
            Ver detalles
        </button>
    </div>
</ng-template>

<ng-template #downloadDocumentButton let-documentId="documentId" let-label="label" let-disabled="disabled">
    <button mat-raised-button class="garantor-button mini" color="primary" (click)="downloadDocument(documentId)" [disabled]="disabled">
        {{ label }}
    </button>
</ng-template>
